import { render, staticRenderFns } from "./database-tables.vue?vue&type=template&id=0911a07a"
import script from "./database-tables.vue?vue&type=script&lang=ts"
export * from "./database-tables.vue?vue&type=script&lang=ts"
import style0 from "./database-tables.vue?vue&type=style&index=0&id=0911a07a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports